/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import { ResponsiveTable, Label, Icon } from '@fitinsur/components';
import * as S from './styles';

function RenderUserList({ formik, listData, setUsersGroup, handleSortList, isBound, getDescription, idGroup }) {

  const removeItem = (listItem) => {

    if (listItem?.idGroupMembership) {
      setUsersGroup((prev) => prev.map((item) => {
        if (item.idUser === listItem.idUser) {
          item.isExpired = true;
        }
        return item;
      }))
      return;
    }

    setUsersGroup((prev) => prev.filter(item => item.idUser !== listItem.idUser));
  }

  const columns = [
    {
      title: getDescription("DOMAIN", 870) || "EMAIL DO USUÁRIO",//"EMAIL DO USUÁRIO",
      value: "userName",
      minWidth: 30,
      maxWidth: 50,
      component: (listItem) => {
        return (
          <>
            <Label wordWrap fontSize={13}>
              {listItem.userName}
            </Label>
          </>
        );
      },
    },
    {
      title: getDescription("DOMAIN",871) || "NOME",//"NOME",
      value: "personName",
      maxWidth: 50,
      notLastColumnAlign: true,
      component: (listItem) => <S.RowWrapper>
        <Label>{listItem.personName}</Label>
        {!!(!isBound && (!listItem.idGroup || listItem.idGroup == idGroup))&&<Icon name="trash" onClick={() => removeItem(listItem)} />}
      </S.RowWrapper>
    },
  ];

  return (
    < ResponsiveTable
      onSortTable={handleSortList}
      formikRef={formik?.current}
      columns={columns}
      data={listData.filter(item => !(item.isExpired))}
    />
  )

}

const components = {
    RenderUserList
}

export { components }